import classNames from "../../lib/classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./Row.module.css";

export default function Row(props) {
    return <div className={classNames(styles.row, props.className)}>{props.children}</div>;
}

Row.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
